/*
 * Copyright (c) 2024 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { CashBoxStateHistoryDto } from '../../../api/cashBoxes/cashBoxesClient.typings';
import {
    CashBoxStateTabAction,
    CashBoxStateTabActionType,
} from '../../../actions/CashBoxRegistry/Tabs/cashBoxStateTabActions';

export interface CashBoxStateTabState {
    cashBoxStateHistory: CashBoxStateHistoryDto;
    isLoadingStateHistory: boolean;
    isDownloadingStateHistory: boolean;
}
const initialState: CashBoxStateTabState = {
    cashBoxStateHistory: null,
    isLoadingStateHistory: false,
    isDownloadingStateHistory: false,
};

export function cashBoxStateTabReducer(
    state: CashBoxStateTabState = initialState,
    action: CashBoxStateTabAction,
): CashBoxStateTabState {
    switch (action.type) {
        case CashBoxStateTabActionType.FETCH_CASHBOX_STATE_HISTORY:
            return {
                ...state,
                isLoadingStateHistory: true,
            };

        case CashBoxStateTabActionType.FETCH_CASHBOX_STATE_HISTORY_SUCCESS:
            return {
                ...state,
                cashBoxStateHistory: action.payload,
                isLoadingStateHistory: false,
            };

        case CashBoxStateTabActionType.FETCH_CASHBOX_STATE_HISTORY_ERROR:
            return {
                ...state,
                isLoadingStateHistory: false,
                cashBoxStateHistory: {
                    count: 0,
                    states: [],
                },
            };

        case CashBoxStateTabActionType.DOWNLOAD_STATE_HISTORY:
            return {
                ...state,
                isDownloadingStateHistory: true,
            };

        case CashBoxStateTabActionType.DOWNLOAD_STATE_HISTORY_SUCCESS:
        case CashBoxStateTabActionType.DOWNLOAD_STATE_HISTORY_ERROR:
            return {
                ...state,
                isDownloadingStateHistory: false,
            };

        case CashBoxStateTabActionType.EXIT_CASHBOX_STATE_TAB:
            return {
                ...state,
                cashBoxStateHistory: null,
            };

        default:
            break;
    }
    return state;
}
